import { render, staticRenderFns } from "./DateView.vue?vue&type=template&id=1c805af2&scoped=true"
import script from "./DateView.vue?vue&type=script&lang=js"
export * from "./DateView.vue?vue&type=script&lang=js"
import style0 from "./DateView.vue?vue&type=style&index=0&id=1c805af2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c805af2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c805af2')) {
      api.createRecord('1c805af2', component.options)
    } else {
      api.reload('1c805af2', component.options)
    }
    module.hot.accept("./DateView.vue?vue&type=template&id=1c805af2&scoped=true", function () {
      api.rerender('1c805af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/date/DateView.vue"
export default component.exports